/**
 * Minimal default template. Hosts that want styling, navigation, or
 * additional metadata should pass a custom `template` to `renderHtml`.
 */
export const DEFAULT_TEMPLATE = `<!DOCTYPE html>
<html lang="en">
<head>
<meta charset="utf-8">
<title>{{title}}</title>
</head>
<body>
{{content}}
</body>
</html>
`;

/**
 * Replace `{{name}}` placeholders in a template string with values from
 * `vars`. Missing keys are replaced with the empty string.
 */
export function applyTemplate(
  template: string,
  vars: Readonly<Record<string, string>>,
): string {
  return template.replace(/\{\{(\w+)\}\}/g, (_match, key: string) => {
    return vars[key] ?? "";
  });
}
